import { createContext } from 'react';

export const AuthContext = createContext({
    user: null,
    userData: null,
    userRef: null,
    loading: true,
});

export const ThemeModeContext = createContext({
    mode: null,
    setMode: null,
});

export const NeighbourContext = createContext({
    neighbourData: null,        // Carga los datos del vecino actual y sus propiedades (carga simple, sin onSnapshot)
	communityData: null,        // Comunidad seleccionada, carga los datos, pero no los arrays de referencias 
    propertiesData: null,       // Propiedades de la comunidad. Estos 3 arrays se cargan bajo demanda con su load
    facilitiesData: null,       // Instalaciones de la comunidad. Estos 3 arrays se cargan bajo demanda con su load
    neighboursData: null,       // Vecinos de la comunidad. Estos 3 arrays se cargan bajo demanda con su load
    deliveriesData: null,       // Paquetes del vecino actual. Se carga bajo demanda con su load
    loadProperties: null,
    loadFacilities: null,
    loadNeighbours: null,
    loadDeliveries: null,
    loading: true,              // Combinacion de los 3 loadings + loading de la comunidad, que no se exporta
});

export const DataContext = createContext({
    announcesData: null,        // Anuncios de la comunidad. Se carga bajo demanda con loadMore
    meetingsData: null,         // Juntas de la comunidad. Se carga bajo demanda con loadMore
    deliveriesData: null,       // Paquetes de la comunidad. Se carga bajo demanda con loadMore
    ticketsData: null,          // Incidencias de la comunidad. Se carga bajo demanda con loadMore
    loadMore: null,
    unsetAllLoaded: null,
    allAnnouncesLoaded: false,
    allMeetingsLoaded: false,
    allDeliveriesLoaded: false,
    allTicketsLoaded: false,
    loading: true,              // Combinacion de los 4 loading internos + loading del context de Neighbour 
});